
const newModel = () => {
    return {
        congTyId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        phamVi: null,
        loaiDiadiemId: null,
        tenLoaiDiadiem: null,
        tenPhanloaiDiadiem: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        congTyId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        phamVi: null,
        loaiDiadiemId: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        congTyId: item.congTyId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        phamVi: item.phamVi,
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        congTyId: item.congTyId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        phamVi: item.phamVi,
        loaiDiadiemId: item.loaiDiadiemId,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phanloaiDiadiemId: null,
        enabled: null,
    }
}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phanloaiDiadiemId: item.phanloaiDiadiemId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        congTyId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        phamVi: null,
        loaiDiadiemId: null,
        phanloaiDiadiemId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const congTyModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


